import { useMediaQuery } from '@vueuse/core';

export function useIsMobile(max_width = '767px') {
    return useMediaQuery(`(max-width: ${max_width})`);
}
